import React from 'react';
import ContainerHeader from '../../components/ContainerHeader/index';
import Button from 'material-ui/Button';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ReportBox from 'components/ReportBox/index';
import { CircularProgress } from 'material-ui/Progress';

import PageSubHeader from '../pagesubheader'

import * as toaster from '../../actions/toaster';
import * as dashboarddetails from '../../actions/dashboarddetails';
import * as loadswitchercommittees from '../../actions/teamdetails';

class Dashboard extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            committee_id: Number(this.props.loginUser && this.props.loginUser.data ? this.props.loginUser.data.committee_id : 0),
        }
    }
    handleChangeTeam(e) {
        this.setState({ committee_id: Number(e.target.value) })
        this.props.actions.fetchCADashboardList(e.target.value);
        this.props.loginUser.data.committee_id = e.target.value;
        this.props.actions.changePreferedTeamIdUser(this.props.loginUser.data)
    }

    componentDidMount() {

        // console.log('comp did mount called ', this.state.committee_id);

        this.props.actions.loadswitchercommittees();
        if (this.state.committee_id ) {
            if (this.props.loginUser && this.props.loginUser.data && this.props.loginUser.data.role_id == '5')
                this.props.history.push('/user/checker-pending-approval')
            if (this.props.params.id == -1)
                this.props.actions.warningToasters('Unauthorised access detected')
            if (this.props.loginUser && this.props.loginUser.data && this.props.loginUser.data.role_id == '3') {
                this.props.actions.fetchCADashboardList(this.state.committee_id);
            }
            if (this.props.loginUser && this.props.loginUser.data && this.props.loginUser.data.role_id == '2') {
                this.props.actions.fetchBADashboardList();
            }
        }
    }

    render() {
        const { getDataList, teamDetails, match, dashboardDetails } = this.props;
        let message = null;
        // console.log('getDataList', getDataList);
        if ((getDataList && getDataList.Status) || (teamDetails && teamDetails.Status)) {
            message = <div className="loader-container"><CircularProgress color="secondary" size={50} /></div>
        }



        return (
            <div className="app-wrapper">
                {message}
                <div className="row">
                    {(this.props.loginUser && this.props.loginUser.data && this.props.loginUser.data.role_id == '3') ?
                        <div className="col-12">
                            <PageSubHeader hideSearch="true" committee_id={this.state.committee_id} handleChangeTeam={this.handleChangeTeam.bind(this)} teamDetails={teamDetails} />
                        </div> : null}
                </div>
                <p className="dashboard">Dashboard</p>
                <div className="d-flex justify-content-center">
                </div>
                <div className="d-flex justify-content-center">
                    <div className="row w-100">
                        <div className="col-lg-4 col-sm-6 col-12">
                            <div className="card shadow_custm d-flex justify-content-center p-4 text-white card-color1">
                                <div className="row">
                                    <div className="col">
                                        <div className="icon">
                                            <i class="zmdi zmdi-accounts-outline zmdi-hc-fw"></i>
                                        </div>
                                    </div>
                                    <div className="col text-right">
                                        <div className="stack-order px-2">
                                            <h1 className="chart-f30 chart-f50">{dashboardDetails && dashboardDetails.dashboarddetails ? dashboardDetails.dashboarddetails.committeeCount : "0"}</h1>
                                            <h3 className="mb-0">Team</h3>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                            <div className="card shadow_custm d-flex justify-content-center p-4 text-white card-color2">
                                <div className="row">
                                    <div className="col">
                                        <div className="icon">
                                            <i class="zmdi zmdi-group-work"></i>
                                        </div>
                                    </div>
                                    <div className="col text-right">
                                        <div className="stack-order px-2">
                                            <h1 className="chart-f50">{dashboardDetails && dashboardDetails.dashboarddetails ? dashboardDetails.dashboarddetails.meetingCount : "0"}</h1>
                                            <h3 className="mb-0">Meeting</h3>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                            <div className="card shadow_custm d-flex justify-content-center p-4 text-white card-color3">
                                <div className="row">
                                    <div className="col">
                                        <div className="icon">
                                            <i class="zmdi zmdi-assignment-check"></i>
                                        </div>
                                    </div>
                                    <div className="col text-right">
                                        <div className="stack-order px-2">
                                            <h1 className="chart-f50">{dashboardDetails && dashboardDetails.dashboarddetails ? dashboardDetails.dashboarddetails.agendaCount : "0"}</h1>
                                            <h3 className="mb-0">Agenda</h3>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                            <div className="card shadow_custm d-flex justify-content-center p-4 text-white card-color4">
                                <div className="row">
                                    <div className="col">
                                        <div className="icon">
                                            <i class="zmdi zmdi-assignment zmdi-hc-fw"></i>
                                        </div>
                                    </div>
                                    <div className="col text-right">
                                        <div className="stack-order px-2">
                                            <h1 className="chart-f50">{dashboardDetails && dashboardDetails.dashboarddetails ? dashboardDetails.dashboarddetails.cdsDocumetsCount : "0"}</h1>
                                            <h3 className="mb-0">Documents</h3>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                            <div className="card shadow_custm d-flex justify-content-center p-4 text-white card-color5">
                                <div className="row">
                                    <div className="col">
                                        <div className="icon">
                                            <i class="zmdi zmdi-case-check"></i>
                                        </div>
                                    </div>
                                    <div className="col text-right">
                                        <div className="stack-order px-2">
                                            <h1 className="chart-f50">{dashboardDetails && dashboardDetails.dashboarddetails ? dashboardDetails.dashboarddetails.resolutionCount : "0"}</h1>
                                            <h3 className="mb-0">Resolutions</h3>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                            <div className="card shadow_custm d-flex justify-content-center p-4 text-white card-color6">
                                <div className="row">
                                    <div className="col">
                                        <div className="icon">
                                            <i class="zmdi zmdi-view-dashboard zmdi-hc-fw"></i>
                                        </div>
                                    </div>
                                    <div className="col text-right">
                                        <div className="stack-order px-2">
                                            <h1 className="chart-f50">{dashboardDetails && dashboardDetails.dashboarddetails ? dashboardDetails.dashboarddetails.decisionCount : "0"}</h1>
                                            <h3 className="mb-0">Decisions</h3>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        {/* <div className="card shadow text-center">
                                <div className="card-header py-3 d-flex justify-content-between bg-primary">
                                    <h3 className="mb-0 text-white">Team</h3>
                                </div>
                                <div className="stack-order  py-4 px-2">
                                    <h1 className="chart-f30">{dashboardDetails && dashboardDetails.dashboarddetails ? dashboardDetails.dashboarddetails.committeeCount : "0"}</h1>
                                </div>
                            </div> */}
                        {/* <div className="col-lg-3 col-sm-6 col-12">
                            <div className="card shadow text-center">
                                <div className="card-header py-3 d-flex justify-content-between bg-primary">
                                    <h3 className="mb-0 text-white">Meeting</h3>
                                </div>
                                <div className="stack-order  py-4 px-2">
                                    <h1 className="chart-f30">{dashboardDetails && dashboardDetails.dashboarddetails ? dashboardDetails.dashboarddetails.meetingCount : "0"}</h1>
                                </div>
                            </div>
                        </div> */}
                        {/* <div className="col-lg-3 col-sm-6 col-12">
                            <div className="card shadow text-center">
                                <div className="card-header py-3 d-flex justify-content-between bg-primary">
                                    <h3 className="mb-0 text-white">Meetings</h3>
                                </div>
                                <div className="stack-order  py-4 px-2">
                                    <h1 className="chart-f30">386,200</h1>
                                </div>
                            </div>
                        </div> */}
                        {/* <div className="col-lg-3 col-sm-6 col-12">
                            <div className="card shadow text-center">
                                <div className="card-header py-3 d-flex justify-content-between bg-primary">
                                    <h3 className="mb-0 text-white">Agenda</h3>
                                </div>
                                <div className="stack-order  py-4 px-2">
                                    <h1 className="chart-f30">{dashboardDetails && dashboardDetails.dashboarddetails ? dashboardDetails.dashboarddetails.agendaCount : "0"}</h1>
                                </div>
                            </div>
                        </div> */}
                        {/* <div className="col-lg-3 col-sm-6 col-12">
                            <div className="card shadow text-center">
                                <div className="card-header py-3 d-flex justify-content-between bg-primary">
                                    <h3 className="mb-0 text-white">Documents</h3>
                                </div>
                                <div className="stack-order  py-4 px-2">
                                    <h1 className="chart-f30">{dashboardDetails && dashboardDetails.dashboarddetails ? dashboardDetails.dashboarddetails.cdsDocumetsCount : "0"}</h1>
                                </div>
                            </div>
                        </div> */}
                        {/* <div className="col-lg-3 col-sm-6 col-12">
                            <div className="card shadow text-center">
                                <div className="card-header py-3 d-flex justify-content-between bg-primary">
                                    <h3 className="mb-0 text-white">Resolutions</h3>
                                </div>
                                <div className="stack-order  py-4 px-2">
                                    <h1 className="chart-f30">{dashboardDetails && dashboardDetails.dashboarddetails ? dashboardDetails.dashboarddetails.resolutionCount : "0"}</h1>
                                </div>
                            </div>
                        </div> */}
                        {/* <div className="col-lg-3 col-sm-6 col-12">
                            <div className="card shadow text-center">
                                <div className="card-header py-3 d-flex justify-content-between bg-primary">
                                    <h3 className="mb-0 text-white">Decisions</h3>
                                </div>
                                <div className="stack-order  py-4 px-2">
                                    <h1 className="chart-f30">{dashboardDetails && dashboardDetails.dashboarddetails ? dashboardDetails.dashboarddetails.decisionCount : "0"}</h1>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>

            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    // console.log(state)
    // console.log(history.go(2))
    const { loginUser, dashboardDetails, teamDetails } = state
    return { params: ownProps.match.params, state, loginUser, dashboardDetails, teamDetails }
}
function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, dashboarddetails, loadswitchercommittees, toaster), dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);



// WEBPACK FOOTER //
// ./app/dashboard/index.js